import { from1DNMRVariables, } from 'convert-to-jcamp';
import { xMultiply } from 'ml-spectra-processing';
export function spectrum1DToJcamp(spectrum, options = {}) {
    const { info, data } = spectrum;
    const { onlyReal = false } = options;
    const { isFid, spectralWidth, frequencyOffset, DECIM, DSPFVS } = info;
    const nucleus = getFirstIfArray(info.nucleus);
    const baseFrequency = getFirstIfArray(info.baseFrequency);
    const originFrequency = getFirstIfArray(info.originFrequency);
    const { x, re, im } = data;
    const newRe = new Float64Array(re);
    const newIm = !onlyReal && im ? new Float64Array(im) : undefined;
    const newMeta = {
        OFFSET: x[0],
    };
    maybeAdd(newMeta, 'SW', spectralWidth);
    maybeAdd(newMeta, 'BF1', baseFrequency);
    if (isFid) {
        const digitalFiltering = lookupForFilter(spectrum, 'digitalFilter');
        if (digitalFiltering) {
            const { value: { digitalFilterValue }, flag: digitalFilterIsApplied, } = digitalFiltering;
            if (digitalFilterIsApplied) {
                const pointsToShift = Math.floor(digitalFilterValue);
                newRe.set(re.slice(re.length - pointsToShift));
                newRe.set(re.slice(0, re.length - pointsToShift), pointsToShift);
                if (im && newIm) {
                    newIm.set(im.slice(im.length - pointsToShift));
                    newIm.set(im.slice(0, im.length - pointsToShift), pointsToShift);
                }
            }
        }
        maybeAdd(newMeta, 'GRPDLY', info.digitalFilter);
        maybeAdd(newMeta, 'DECIM', DECIM);
        maybeAdd(newMeta, 'DSPFVS', DSPFVS);
    }
    let shiftReference;
    if (frequencyOffset && baseFrequency) {
        const offset = frequencyOffset / baseFrequency;
        shiftReference = offset + 0.5 * spectralWidth;
    }
    else {
        shiftReference = x[x.length - 1];
    }
    const newInfo = {
        '.SHIFT REFERENCE': `INTERNAL, ${String(info.solvent)}, ${info.isFid ? x.length : 1}, ${shiftReference}`,
        NPOINTS: x.length,
        '.OBSERVE NUCLEUS': nucleus,
        '.OBSERVE FREQUENCY': originFrequency,
        dataType: info.isFid ? `NMR FID` : `NMR SPECTRUM`,
        dataClass: !onlyReal && im ? 'NTUPLES' : 'XYDATA',
    };
    maybeAdd(newInfo, '.SOLVENT', info.solvent);
    maybeAdd(newInfo, 'owner', info.owner);
    const jcampOptions = {
        xyEncoding: 'DIFDUP',
        info: newInfo,
        meta: newMeta,
    };
    // the order of variables in the object is important
    const variables = {
        x: {
            data: info.isFid ? x : xMultiply(x, originFrequency),
            label: info.isFid ? 'TIME' : 'FREQUENCY',
            units: info.isFid ? 'second' : 'HZ',
            symbol: 'X',
        },
        r: {
            data: newRe,
            label: `${info.isFid ? 'FID' : 'SPECTRUM'}/REAL`,
            units: 'ARBITRARY UNITS',
            symbol: 'R',
        },
    };
    if (newIm) {
        variables.i = {
            data: newIm,
            label: `${info.isFid ? 'FID' : 'SPECTRUM'}/IMAG`,
            units: 'ARBITRARY UNITS',
            symbol: 'I',
        };
    }
    return from1DNMRVariables(variables, jcampOptions);
}
function getFirstIfArray(data) {
    return Array.isArray(data) ? data[0] : data;
}
function maybeAdd(obj, name, value) {
    if (value === undefined)
        return;
    obj[name] = getFirstIfArray(value);
}
function lookupForFilter(spectrum, filterName) {
    return spectrum.filters.find((f) => f.name === filterName);
}
//# sourceMappingURL=spectrum1DToJcamp.js.map